module.exports = __webpack_public_path__ + "img/github.294bbfc5.svg";